/* CalmRuffy – en-tête produit original */
(function () {
  var ICONS = [
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 21s-7-4.4-9.3-9A5.3 5.3 0 0 1 12 6.6 5.3 5.3 0 0 1 21.3 12C19 16.6 12 21 12 21z"/></svg>',
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 16 16 3l5 5L8 21z"/><path d="m7 12 2 2M10 9l2 2M13 6l2 2"/></svg>',
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 19c0-8 6-14 15-14 0 9-6 15-14 15"/><path d="M5 19 13 11"/></svg>',
    '<svg viewBox="0 0 24 24" fill="currentColor"><ellipse cx="6" cy="9" rx="2.2" ry="2.8"/><ellipse cx="10.5" cy="5.5" rx="2.2" ry="2.8"/><ellipse cx="15.5" cy="5.5" rx="2.2" ry="2.8"/><ellipse cx="19.5" cy="9.5" rx="2.1" ry="2.7"/><path d="M12.8 11.2c2.6 0 6 4.4 6 6.8 0 1.8-1.4 2.6-3 2.6-1.3 0-2-.6-3-.6s-1.8.6-3.2.6c-1.7 0-2.9-.9-2.9-2.6 0-2.4 3.5-6.8 6.1-6.8z"/></svg>'
  ];
  function init() {
    var head = document.querySelector('.cr-head');
    if (!head || head.hasAttribute('data-crh')) return;
    head.setAttribute('data-crh', '');
    var h1 = document.querySelector('.product-details h1');
    if (h1 && !h1.querySelector('.crh-brand')) {
      var m = h1.textContent.match(/^\s*(CalmRuffy™?)/);
      if (m) h1.innerHTML = '<span class="crh-brand">' + m[1] + '</span>' + h1.textContent.slice(m[0].length).replace(/[&<>]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;' }[c]; });
      var block = h1.closest('.text-block') || h1;
      block.insertAdjacentHTML('beforebegin', '<div class="crh-chip-wrap"><span class="crh-chip"><i><svg viewBox="0 0 24 24" fill="currentColor"><path d="M13 2 4 14h7l-1 8 9-12h-7z"/></svg></i>Made for <span class="crh-rot" aria-live="off"><span class="is-on">storms</span><span>fireworks</span><span>vacuum days</span><span>bath time</span><span>car rides</span></span></span></div>');
    }
    var rot = document.querySelector('.crh-rot');
    if (rot && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var words = rot.children, i = 0;
      setInterval(function () {
        var cur = words[i]; i = (i + 1) % words.length; var nxt = words[i];
        cur.classList.remove('is-on'); cur.classList.add('is-out');
        nxt.classList.remove('is-out'); nxt.classList.add('is-on');
        setTimeout(function () { cur.classList.remove('is-out'); }, 500);
      }, 2000);
    }
    var price = head.querySelector('.cr-head__price');
    if (price) {
      price.classList.add('crh-tag');
      var row = document.createElement('div'); row.className = 'crh-pricerow';
      price.parentNode.insertBefore(row, price); row.appendChild(price);
      row.insertAdjacentHTML('beforeend', '<button type="button" class="crh-duo">Get 2, <b>2nd one 50% off</b> &rarr;</button>');
      row.querySelector('.crh-duo').addEventListener('click', function () {
        var k = document.querySelector('.kaching-bundles__block') || document.querySelector('.kaching-bundles') || document.querySelector('.add-to-cart-button');
        if (k) k.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
    head.querySelectorAll('.cr-head__list li .cr-head__check').forEach(function (c, i) { c.innerHTML = ICONS[i % ICONS.length]; });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
